import styled from "styled-components";

const LatestActivityWrapper = styled.div`
  .img-sm {
    width: 41px;
    height: 41px;
    border-radius: 50%;
    object-fit: cover;
  }
`;

export default LatestActivityWrapper;
